import { createContext } from 'react'

const notifyContext = createContext()

export default notifyContext
